<template>
  <div>
    <data-table :service="ClientServe"
                operations="add"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                service-method="getClientContracts"
                :service-path="servicePath"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                :clickable="false"
                @on-row-click="onRowClick"
                @on-add="addClientContract"
                ref="table">
      <template v-slot:title="{row}">
        {{row.title}}
      </template>
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:valid_till="{row}">
        {{$formatDate(row.valid_till, FRIENDLY_DATETIME_FORMAT) || $t('generic.na')}}
      </template>
      <template v-slot:amount="{row}">
        {{row.amount}}
      </template>
      <template v-slot:amount_used="{row}">
        {{row.amount_used}}
      </template>
      <template v-slot:amount_open="{row}">
        {{row.amount_open}}
      </template>
      <template v-slot:job_board="{row}">
        <router-link :to="`/job-board/${getByKey(row, 'product_job_board.job_board.id')}`" @click.native.stop="">
          {{getByKey(row, 'product_job_board.job_board.name')}}
        </router-link>
      </template>
      <template v-slot:product="{row}">
        <router-link :to="`/settings/products/${getByKey(row, 'product_job_board.product_id')}`" @click.native.stop="">
          {{getByKey(row, 'product_job_board.name', $t('generic.na'))}}
        </router-link>
      </template>
    </data-table>

    <add-contracts-modal v-if="showAddModal && client"
                       :show.sync="showAddModal"
                       :client="client"
                       @submit="addContracts">
    </add-contracts-modal>
  </div>
</template>
<script>
  import getByKey from 'lodash/get'
  import Vue from 'vue'
  import { DatePicker } from 'element-ui'
  import { mapState } from 'vuex'
  import ClientServe from 'src/services/ClientService'
  import entities from 'src/config/entities'
  import AddContractsModal from './AddContractsModal'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'
  import { getRouteName } from 'src/config/routeTypes'
  import ContractService from 'src/services/ContractService'

  Vue.use(DatePicker)
  export default {
    name: 'client-management-contracts',
    components: {
      AddContractsModal
    },
    data () {
      return {
        ClientServe,
        entity: entities.CONTRACT,
        FRIENDLY_DATETIME_FORMAT,
        showAddModal: false
      }
    },
    computed: {
      ...mapState({
        client: state => state.client.currentClient
      }),
      columns () {
        return [
          {
            prop: 'title',
            label: this.$t('contract.list.labels.name'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'valid_till',
            label: this.$t('contract.list.labels.validTill'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'amount',
            label: this.$t('contract.list.labels.total'),
            minWidth: '80px',
            sortable: true
          },
          {
            prop: 'amount_used',
            label: this.$t('contract.list.labels.used'),
            minWidth: '80px',
            sortable: true
          },
          {
            prop: 'amount_open',
            label: this.$t('contract.list.labels.open'),
            minWidth: '90px',
            sortable: true,
          },
          {
            prop: 'job_board',
            label: this.$t('contract.list.labels.job_board'),
            minWidth: '120px'
          },
          {
            prop: 'product',
            label: this.$t('contract.list.labels.product'),
            minWidth: '140px'
          }
        ]
      },
      filters () {
        return [
          {
            key: 'sort',
            value: '+updated_at'
          }
        ]
      },
      servicePath() {
        return `/clients/${this.$route.params.id}/contracts`
      },
    },
    methods: {
      getByKey,
      getError (name) {
        return this.errors.first(name)
      },
      refreshTable () {
        this.$refs.table.refresh()
      },
      async addContracts (data) {
        await ContractService.create(data)
        this.showAddModal = false
        this.refreshTable()
      },
      addClientContract () {
        this.showAddModal = true
      },
      onRowClick(row) {
        this.$router.push({
          name: getRouteName('contract-details', entities.CLIENT),
          params: {
            contractId: row.id
          }
        })
      }
    }
  }
</script>
<style>
</style>
